import { Component } from '@angular/core';
import { Router } from '@angular/router';

import {
    Animations,
    AntragResponse,
    BackendOberflaecheService,
    DownloadService,
    Helper,
    OberflaecheElement,
    RateService,
    SetAntragProvider,
    StandardBeitragComponent,
    TarifierungResponse
} from '@vhv/tarifrechner-common';

import { SendeAntragsdatenBaugeraeteService } from '../../service/sende-antragsdaten-baugeraete.service';
import { BehaviorSubject } from 'rxjs';
import { DateTime } from 'luxon';

@Component({
    animations: [Animations.slideInDownAnimation],
    templateUrl: "baugeraete-zusammenfassung.component.html",
})
export class BaugeraeteZusammenfassungComponent extends StandardBeitragComponent {

    isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    public foo = true;

    public currentRate: TarifierungResponse;
    public zusaetzlicheAbsicherung: boolean;
    public feuerrisiko: boolean;
    public minderertragsdeckung: boolean;

    private ausgefuellteWerte: any;

    constructor(
        public rateService:RateService,
        private _inputRouter: Router,
        private _inputBackendOberflaecheService: BackendOberflaecheService,
        private _setAntragProvider: SetAntragProvider,
        private sendeAntragsdatenService: SendeAntragsdatenBaugeraeteService,
        private _downloadService: DownloadService
    ) {
        super();

        if (this._inputBackendOberflaecheService.getElementByName('IstDirektionsanfrage').value === 'false') {
            this.rateService.calculateBeitrag();
            this.rateService.getBeitrag().then(value => {
                this.currentRate = value
            }).catch(error => {
                console.log('Beitrag kann nicht ermittelt werden: ' + error);
            });
        } else {
            this.currentRate = null;
        }

    }

    private setOberflaecheElemente() {
        this.ausgefuellteWerte = this._inputBackendOberflaecheService.getAusgefuellteWerte();
        this.zusaetzlicheAbsicherung = false;
        if (this.ausgefuellteWerte['FeuerMitVersichern'] === "true") {
            this.feuerrisiko = true;
            this.zusaetzlicheAbsicherung = true;
        }
        if (this.ausgefuellteWerte['Minderertragsversicherung'] === "true") {
            this.minderertragsdeckung = true;
            this.zusaetzlicheAbsicherung = true;
        }
    }

    initialiseSeite(): void {
        super.initialiseSeite();
        this.setOberflaecheElemente();
    }

    onSubmit() {
        this.isLoading.next(true);
        this._setAntragProvider.setAntrag(this.sendeAntragsdatenService.getAntragRequest())
            .then( (value: AntragResponse) => {
                this._downloadService.setAntragskopie(value.dateien[0].inhalt);
                super.onSubmit();
                this.isLoading.next(false);
            })
            .catch(() => {
                this._inputRouter.navigate(['/error']);
                this.isLoading.next(false);
            });
    }

    getSubmitButtonText():string {
        if (this._inputBackendOberflaecheService.getElementByName('IstDirektionsanfrage').value === 'false') {
            return 'Jetzt beitragspflichtig abschließen';
        }

        return 'Jetzt Anfrage stellen';
    }

    updateRate = (newRate: TarifierungResponse): void => {
        this.currentRate = newRate;
    };

    getOberflaechenElementWert(element:string):string {
        return this._inputBackendOberflaecheService.getElementByName(element).value;
    }

    getVersicherungsbeginn():string {
        if (this.getOberflaechenElementWert('Versicherungsbeginn')) {
            return Helper.dateStringToDeLocaleString(this.getOberflaechenElementWert('Versicherungsbeginn'));
        }
        return '';
    }

    getOberflaechenElementEintraegeWert(elementName:string):string {
        const element:OberflaecheElement = this._inputBackendOberflaecheService.getElementByName(elementName);
        return element.oberflaecheWerteEintraege.find( (value: any) => {
            return (value.inhalt === element.value);
        }).anzeige;
    }

    getVersicherungsablauf():string{
        const datum = DateTime.fromFormat(this.getVersicherungsbeginn(), 'dd.MM.yyyy');
        return datum.plus({ years: +this.getOberflaechenElementWert("Vertragslaufzeit")}).toFormat('dd.MM.yyyy');
    }

}
